import { Avatar, Box, CssBaseline, IconButton, Toolbar } from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import { styled } from "@mui/material/styles";
import { KW_LOGO, PLACEHOLDER_IMAGE } from "constant";
import { menu, subMenu } from "constant/menu";
import MagnifyingGlassIcon from "lib/assets/svg/magnifying-glass";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { getCount, getUser } from "store/selector";
import { onSignOut } from "store/services";
import { actions } from "store/slice";
import { errorToaster, successToaster } from "utils/alerts";
import { trackButtonClick, trackEvent } from "utils/analytics";
import { filteredMenu } from "utils/filtered-menu";
import { getItem, removeItem } from "utils/local-storage";
import { useFetchAllProfiles } from "hooks/use-fetch-all-profiles";
import {
  getIsFormChanged,
  getProfile,
  getProfileImage,
} from "view/profile/store/selector";
import { saveProfile } from "view/profile/store/services";
import {
  getFilter,
  getPagination,
  getSearch,
  getSort,
} from "view/search-profile/store/selector";
import { actions as searchProfileActions } from "view/search-profile/store/slice";

const AppBar = styled(MuiAppBar)(({ theme }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

const DesktopHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const profileImage = useSelector(getProfileImage);
  const { token } = useSelector(getUser);
  const profileObj = useSelector(getProfile);
  const isFormChanged = useSelector(getIsFormChanged);
  const count = useSelector(getCount);
  const currentUser = getItem("current_user");
  const [profileHover, setProfileHover] = useState(false);
  const filteredMenuItems = filteredMenu(menu, token);
  const dropdownmenuRef = useRef(null);

  // Search Profiles related states
  const { fetchProfiles } = useFetchAllProfiles();
  const sort = useSelector(getSort);
  const filter = useSelector(getFilter);
  const search = useSelector(getSearch);
  const pagination = useSelector(getPagination);
  const { currentPage } = pagination;
  const { minAge, maxAge, profilesAvailability, rasi } = filter;

  const handleClickSave = () => {
    dispatch(actions.setLoading(true));
    saveProfile(token, {
      ...profileObj,
      ...currentUser,
    })
      .then((res) => {
        dispatch(actions.setLoading(false));
        if (res.data.success) {
          successToaster("Profile Updated Successfully!!!", 4000);
          trackEvent("tutorial_step_complete", {
            tutorial_name: "registration_flow",
            step_name: "profile_update",
          });
        }
      })
      .catch(
        (err) =>
          err &&
          errorToaster(
            "Facing issue in saving profile. Please Try After Sometime!!!",
            4000
          )
      );
  };

  useEffect(() => {
    const handleClickOutsideDropdown = (event) => {
      if (
        dropdownmenuRef.current &&
        !dropdownmenuRef.current.contains(event.target)
      ) {
        setProfileHover(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutsideDropdown);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideDropdown);
    };
  }, []);

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <CssBaseline />
      <AppBar position="fixed">
        <Toolbar
          style={{
            backgroundColor: "#f4f7fc",
          }}
        >
          <nav
            className="navbar navbar-expand-lg"
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              onClick={() => navigate("/")}
              src={KW_LOGO}
              alt="kalyanawaran"
              width={225}
              fetchpriority="high"
              loading="eager"
            />

            <div
              className="collapse navbar-collapse"
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "flex-end",
              }}
              id="navbarSupportedContent"
            >
              <ul className=" mt-3 d-flex align-items-center justify-content-center">
                {/* <Localization /> */}
                {location.pathname === "/search-profiles" && (
                  <div className=" d-flex align-items-center justify-content-center">
                    <input
                      placeholder="Search for Grooms, Brides..."
                      className=" form-control"
                      onChange={(e) =>
                        dispatch(searchProfileActions.setSearch(e.target.value))
                      }
                    />
                    <button
                      className=" btn btn-primary mx-3"
                      onClick={() =>
                        fetchProfiles(
                          search,
                          minAge,
                          maxAge,
                          rasi,
                          sort,
                          currentPage,
                          profilesAvailability
                        )
                      }
                    >
                      <MagnifyingGlassIcon />
                    </button>
                  </div>
                )}
                {filteredMenuItems.map(({ name, icon: Icon, link }, index) => (
                  <div
                    key={index}
                    style={{
                      marginBottom: "5px",
                    }}
                    className=" px-3 mx-3 mt-2"
                    data-tour={`nav-${name}`}
                  >
                    <Link
                      to={link}
                      className="btn"
                      style={{
                        display: "inline-block",
                        textDecoration: "none",
                        padding: "5px 0",
                        marginBottom: "5px",
                        color: location.pathname !== link ? "gray" : "#037afb",
                      }}
                      onClick={() => {
                        trackButtonClick(name, "header_menu");
                      }}
                    >
                      <Icon width={16} height={16} /> {`  ${name}`}
                    </Link>
                  </div>
                ))}
                {location.pathname === "/profileedit" && (
                  <button
                    className="btn btn-primary"
                    style={{ marginRight: "10px" }}
                    onClick={handleClickSave}
                    disabled={!isFormChanged}
                  >
                    Save
                  </button>
                )}
              </ul>
              {token && (
                <div style={{ cursor: "pointer", position: "relative" }}>
                  <IconButton onClick={() => setProfileHover(!profileHover)}>
                    <Avatar
                      alt="Remy Sharp"
                      src={
                        profileImage === "" ? PLACEHOLDER_IMAGE[50] : profileImage
                      }
                    />
                  </IconButton>
                  {profileHover && (
                    <div
                      style={{
                        width: "max-content",
                        top: "55px",
                        right: "-10px",
                        borderRadius: ".5rem",
                        boxShadow: " 0 3px 10px rgba(62, 85, 120, .045)",
                      }}
                      className="text-black  py-2 bg-white position-absolute"
                      ref={dropdownmenuRef}
                    >
                      <div className="border-bottom">
                        <div>
                          {(getItem("current_user")?.username ||
                            getItem("current_user")?.userId) && (
                            <div className="nav-item">
                              <b>User Info</b>
                            </div>
                          )}
                          {getItem("current_user")?.username && (
                            <h6 className="nav-item">
                              User Name:{" "}
                              <span
                                style={{ fontStyle: "italic", opacity: ".5" }}
                              >
                                {getItem("current_user")?.username || ""}
                              </span>
                            </h6>
                          )}
                          {getItem("current_user")?.userId && (
                            <h6 className="nav-item">
                              User Id:{" "}
                              <span
                                style={{ fontStyle: "italic", opacity: ".5" }}
                              >
                                {getItem("current_user")?.userId || ""}
                              </span>
                            </h6>
                          )}
                          {subMenu.map(({ name, link }, index) => (
                            <h6
                              key={index}
                              className="nav-item"
                              onClick={() => navigate(link)}
                            >
                              {name}
                            </h6>
                          ))}
                          <h6 className="nav-item">Count: {count}</h6>
                        </div>
                      </div>
                      <div
                        onClick={() => {
                          if (token) {
                            removeItem("the_main_app");
                            removeItem("current_user");
                            onSignOut(token)
                              .then((res) => res)
                              .catch((err) => console.error("err", err));
                            window.location.reload(false);
                          }
                        }}
                      >
                        <h6 className="nav-item">Log Out</h6>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </nav>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default DesktopHeader;
